<template>
    <div class="px-6">
        <v-overlay absolute :value="downloading" color="white" opacity="0.3" z-index="9">
            <v-progress-circular indeterminate color="#1DBC97" size="100" width="8"></v-progress-circular>
        </v-overlay>
        <v-row class="hcdashdepart-row-page mt-3 pl-2">
            <v-col cols="auto" md="auto" lg="auto" class="pa-0" align-self="center">
                <v-tabs hide-slider background-color="#FFFEFE" class="border-tab-hcdashdepart" v-model="tab" height="58">
                    <v-tab class="font-tab-hcdashdepart" href="#tabItem" active-class="active-tab-hcdashdepart">ITEM</v-tab>
                    <v-tab class="font-tab-hcdashdepart" href="#tabDepartment" active-class="active-tab-hcdashdepart">DEPARTMENT</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-row class="hcdashdepart-row-page mt-6">   
            <v-col align-self="start" cols="12" md="auto" lg="auto" class="pl-5 pr-0 py-0">
                <v-row class="hcdashdepart-row-page font-title-hcdashdepart">
                    DASHBOARD PETTY
                </v-row>
                <v-row class="hcdashdepart-row-page font-title-hcdashdepart">
                    DEPARTMENT
                </v-row>
            </v-col>  
             <v-spacer></v-spacer>
             <!-- temp comment -->
            <v-col cols="auto" md="auto" lg="auto" class=" px-0 pb-0 padding-btn-refresh-depart-power-bi btn-pd-refresh-depart-power-bi" align-self="end">
                <v-btn @click="refresh()" height="40" depressed class="rounded-lg  btn-refresh-depart-power-bi" color="#1DBC97" >
                    <v-icon small class="mr-2" color="#1DBC97">mdi-refresh</v-icon>
                    <span class="font-text-refresh-depart-power-bi">Refresh ข้อมูล Power BI</span>
                </v-btn>
            </v-col> 
        </v-row>
        <v-row justify="end" class="row-dashboard-power-bi text-showdate-depart-power-bi mt-2">{{message}}</v-row>
        <v-tabs-items v-model="tab" class="mt-3 background-tab-hcdashdepart">
            <v-tab-item value="tabItem">
                <v-card elevation="0" class="pt-5 border-cardgrahp-hcdashdepart card-height-depart-power-bi">
                    <iframe id="iframeid1" title="PB_Prd_test" width="100%" height="100%" :src="item" frameborder="0" allowFullScreen="true"></iframe>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tabDepartment">
                <v-card elevation="0" class="pt-5 border-cardgrahp-hcdashdepart card-height-depart-power-bi">
                    <iframe id="iframeid2" title="PB_Prd_test" width="100%" height="100%" :src="department" frameborder="0" allowFullScreen="true"></iframe>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>

export default {
    data: () => ({
        tab: null,
        item:  '',
        department: '',
        dataset_list:[],
        success_count:0,
        id:'',
        message:'',
        downloading:false
    }),
    mounted() {
        this.getPowerBi()
    },
    methods: {
        async getPowerBi() {
        this.downloading = true
        try {
          let tax_id = '0107544000094'
          const url = `/petty_cash/api/v1/id_powerbi?tax_id=${tax_id}`
          const { data } = await this.axios.get(this.$api_url + url)
          if(data.status){
            this.item = data.data[0].iframe_list[1]
            this.department = data.data[0].iframe_list[2]
            this.dataset_list = data.data[0].dataset_list
            this.id = data.data[0]._id
            //----- เรียกฟังก์ชั่น วันที่อัปเดตข้อมูลล่าสุด -----//
            this.getDatasetHistory(this.dataset_list[0])
          }
        } catch (error) {
          console.log(error)
        }finally{
            this.downloading = false
        }
      },
      async refresh() {
        this.downloading = true
        try {
            const url = `/petty_cash/api/v1/refresh_powerbi`
            var { data } = await this.axios.post(this.$api_url + url, {
                dataset_list : this.dataset_list,
                date:new Date(),
                id:this.id
            })
            if(data.status){
                this.success_count = data.result 
                this.getDatasetHistory(this.dataset_list[0])
                document.getElementById('iframeid1').src += ''
                document.getElementById('iframeid2').src += ''
            }else{
                this.message = data.message
            }
        } catch (error) {
          console.log(error)
        }finally{
            this.downloading = false
        }
      },
        async getDatasetHistory(dataset) {
        try {
            const url = `/petty_cash/api/v1/get_history_dataset`
            var { data } = await this.axios.post(this.$api_url + url, {
                dataset_id : dataset
            })
            if(data.status){
                this.message = `วันที่อัปเดตข้อมูลล่าสุด : ${this.$options.filters.shortmonthyearandtime(data.result[0].endTime)}`
                //this.message = `${this.message.substring(0,10).split('-')[2]}/${this.message.substring(0,10).split('-')[1]}/${this.message.substring(0,10).split('-')[0]}`
            }
        } catch (error) {
          console.log(error)
        }
      }
    },
    computed: {

      }
}
</script>

<style>
    .btn-pd-refresh-depart-power-bi{
        padding-top: 0% !important;
    }
    .hcdashdepart-row-page {
        width: 100%;
        margin: 0% !important;
    }

    .font-title-hcdashdepart {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 24px !important;
        color: #000000;
    }

    .border-tab-hcdashdepart {
        border-radius: 30px !important; 
    }

    .font-tab-hcdashdepart {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 24px !important;
        color: #C7C4C4 !important;
    }

    .active-tab-hcdashdepart {
        font-weight: 600;
        color: white !important;
        background-color: #21B5B3;
        border-radius: 30px !important; 
    }

    .background-tab-hcdashdepart {
        background-color: transparent !important;
        border-radius: 15px !important;
    }

    .border-cardgrahp-hcdashdepart {
        border-radius: 15px !important;
    }

    .card-height-depart-power-bi {
        height: calc(100vh - 300px) !important;
    }
    .btn-refresh-depart-power-bi {
    background-color: white !important;
    }
    .font-text-refresh-depart-power-bi {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #1DBC97;
    text-transform: capitalize;
    }  
    .text-showdate-depart-power-bi {
        font-family: 'Noto Sans Thai', sans-serif;
        font-size: 12px !important;
        color: black;
    }

     @media only screen and (max-width:600px){ /*css for mobile screen*/

        .font-tab-hcdashdepart {
            font-size: 18px !important;
        }

        .card-height-depart-power-bi {
            height: calc(100vh - 346px) !important;
        }
        .padding-btn-refresh-depart-power-bi {
        margin-left: auto;
        }
        .btn-pd-refresh-depart-power-bi{
        padding-top: 2% !important;
    }
     }

</style>